/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
    DividendPaymentNotificationDto,
    DividendPaymentNotificationDtoFromJSON,
    DividendPaymentNotificationDtoFromJSONTyped,
    DividendPaymentNotificationDtoToJSON,
} from './DividendPaymentNotificationDto';
import {
    PortfolioMilestoneReachedNotificationDto,
    PortfolioMilestoneReachedNotificationDtoFromJSON,
    PortfolioMilestoneReachedNotificationDtoFromJSONTyped,
    PortfolioMilestoneReachedNotificationDtoToJSON,
} from './PortfolioMilestoneReachedNotificationDto';
import {
    PortfolioValueChangedNotificationDto,
    PortfolioValueChangedNotificationDtoFromJSON,
    PortfolioValueChangedNotificationDtoFromJSONTyped,
    PortfolioValueChangedNotificationDtoToJSON,
} from './PortfolioValueChangedNotificationDto';

/**
 * @type NotificationDto
 * 
 * @export
 */
export type NotificationDto = { type: 'dividendPayment' } & DividendPaymentNotificationDto | { type: 'portfolioMilestoneReached' } & PortfolioMilestoneReachedNotificationDto | { type: 'portfolioValueChanged' } & PortfolioValueChangedNotificationDto;

export function NotificationDtoFromJSON(json: any): NotificationDto {
    return NotificationDtoFromJSONTyped(json, false);
}

export function NotificationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotificationDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    switch (json['type']) {
        case 'dividendPayment':
            return {...DividendPaymentNotificationDtoFromJSONTyped(json, true), type: 'dividendPayment'};
        case 'portfolioMilestoneReached':
            return {...PortfolioMilestoneReachedNotificationDtoFromJSONTyped(json, true), type: 'portfolioMilestoneReached'};
        case 'portfolioValueChanged':
            return {...PortfolioValueChangedNotificationDtoFromJSONTyped(json, true), type: 'portfolioValueChanged'};
        default:
            throw new Error(`No variant of NotificationDto exists with 'type=${json['type']}'`);
    }
}

export function NotificationDtoToJSON(value?: NotificationDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    switch (value['type']) {
        case 'dividendPayment':
            return {...DividendPaymentNotificationDtoToJSON(value), type: 'dividendPayment'};
        case 'portfolioMilestoneReached':
            return {...PortfolioMilestoneReachedNotificationDtoToJSON(value), type: 'portfolioMilestoneReached'};
        case 'portfolioValueChanged':
            return {...PortfolioValueChangedNotificationDtoToJSON(value), type: 'portfolioValueChanged'};
        default:
            throw new Error(`No variant of NotificationDto exists with 'type=${value['type']}'`);
    }
}

